export default __webpack_public_path__ + "static/media/ic_file.689cae62.svg";